import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { buildLocalizedPath } from "../lib/langRoutes";

export const Footer = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] || "de";
  const localTreatment = (slug) => `${buildLocalizedPath("treatments", lang)}/${slug}`;
  return (
    <footer data-testid="site-footer" className="bg-[#3E5239] text-[#F6F5F2]/80">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src="/kosmedico-logo.svg" alt="Kosmedico" className="h-20 w-auto brightness-0 invert opacity-90" />
            <p className="mt-6 text-sm font-light max-w-sm leading-relaxed text-[#F6F5F2]/70">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-[#A7CA99] mb-4">{t("footer.treatments_title")}</div>
            <ul className="space-y-3 text-sm font-light">
              <li><Link to={localTreatment("botox")} className="hover:text-[#A7CA99] transition-colors">{t("treatments.items.botox.title")}</Link></li>
              <li><Link to={localTreatment("hialuronico")} className="hover:text-[#A7CA99] transition-colors">{t("treatments.items.hyaluron.title")}</Link></li>
              <li><Link to={localTreatment("nanoneedling")} className="hover:text-[#A7CA99] transition-colors">{t("treatments.items.nano.title")}</Link></li>
              <li><Link to={localTreatment("labios")} className="hover:text-[#A7CA99] transition-colors">{t("treatments.items.lippen.title")}</Link></li>
              <li><Link to={localTreatment("sculptra")} className="hover:text-[#A7CA99] transition-colors">{t("treatments.items.sculptra.title")}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-[#A7CA99] mb-4">{t("footer.contact_title")}</div>
            <ul className="space-y-3 text-sm font-light">
              <li>{t("contact.address_line")}</li>
              <li>{t("contact.phone_value")}</li>
              <li>{t("contact.email_value")}</li>
              <li>{t("contact.hours_value")}</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#F6F5F2]/10">
          <div className="font-serif text-[16vw] md:text-[10vw] leading-[0.9] text-[#A7CA99]/15 select-none">
            Kosmedico
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-[#F6F5F2]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs font-light text-[#F6F5F2]/50">
          <div>© {new Date().getFullYear()} Kosmedico Zürich. {t("footer.rights")}</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link data-testid="footer-impressum-link" to={buildLocalizedPath("impressum", lang)} className="hover:text-[#A7CA99] transition-colors">{t("legal.impressum", "Impressum")}</Link>
            <Link data-testid="footer-agb-link" to={buildLocalizedPath("agb", lang)} className="hover:text-[#A7CA99] transition-colors">{t("legal.agb", "AGB")}</Link>
            <Link data-testid="footer-datenschutz-link" to={buildLocalizedPath("datenschutz", lang)} className="hover:text-[#A7CA99] transition-colors">{t("legal.datenschutz", "Datenschutz")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
